/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";
import { Button } from "react-bootstrap";
import he from "he";
import { Editor } from "primereact/editor";
import api from "../../utils/api";
import {
  FiArrowLeft,
  FiHome,
  FiChevronRight,
  FiBook,
  FiFileText,
  FiList,
  FiAward,
  FiHelpCircle,
  FiCheckCircle,
  FiXCircle,
  FiType,
  FiUpload,
  FiSave,
  FiX,
  FiPlus,
  FiEdit,
  FiTrash2,
  FiEye
} from 'react-icons/fi';
import Select from "react-select";

const AddQuestion = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [selectedModule, setSelectedModule] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedChapter, setSelectedChapter] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedQuestionType, setSelectedQuestionType] = useState("");
  const [selectedExamType, setSelectedExamType] = useState([]);
  const [examTypes, setExamTypes] = useState([]);
  const [ID, setID] = useState(null);
  const [modules, setModules] = useState([]);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [levels, setLevels] = useState([]);
  const [questionType, setQuestionType] = useState([]);
  const [examType, setExamType] = useState("");
  const [questionText, setQuestionText] = useState("");
  const [options, setOptions] = useState([]);
  const [optionValues, setOptionValues] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [explanation, setExplanation] = useState("");
  const [answer, setAnswer] = useState("");
  const [noOfOptions, setNoOfOptions] = useState(0);
  const [userPermissions, setUserPermissions] = useState({});
  const [showPreview, setShowPreview] = useState(false);

  // Add Chapter modal
  const [showAddChapter, setShowAddChapter] = useState(false);
  const [newChapterName, setNewChapterName] = useState("");
  const [chapterLoading, setChapterLoading] = useState(false);

  // Add Topic modal
  const [showAddTopic, setShowAddTopic] = useState(false);
  const [newTopicName, setNewTopicName] = useState("");
  const [topicLoading, setTopicLoading] = useState(false);

  const [tagInput, setTagInput] = useState("");
  const [tags, setTags] = useState([]);

  const handleTagKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const value = tagInput.trim();

      if (!value) return;

      if (!tags.includes(value)) {
        setTags([...tags, value]);
      }

      setTagInput("");
    }
  };

  const removeTag = (index) => {
    const updated = tags.filter((_, i) => i !== index);
    setTags(updated);
  };

  useEffect(() => {
    if (id) {
      setID(id);
    }
  }, [id]);

  useEffect(() => {
    auth();

  }, []);

  async function auth() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getPagePermission";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);
      fd.append("pageNo", 7);

      const response = await api.post("user/userCurl", fd);
      if (response.data && response.data.data.length > 0) {
        setUserPermissions(response.data.data[0]);
      }
    } catch (error) {
      setUserPermissions({});
      toast.error("Error fetching permissions.");
    } finally {
      setLoading(false);
    }
  }

  async function fetchModules() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getAllDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const modulesResponse = await api.post("module/moduleCurl", fd);

      console.log("Modules response:", modulesResponse);
      if (Array.isArray(modulesResponse.data.getResponse)) {
        setModules(modulesResponse.data.getResponse);
      } else {
        setModules([]);
      }
    } catch (error) {
      setModules([]);
    }
  }

  async function fetchCourses(moduleId) {
    if (!moduleId) {
      setCourses([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getCourseOnchange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("id", moduleId);

      const courseResponse = await api.post("onchange/onchangeCurl", fd);
      if (Array.isArray(courseResponse.data)) {
        setCourses(courseResponse.data);
      } else {
        setCourses([]);
      }
    } catch (error) {
      setCourses([]);
    }
  }

  async function fetchSubjects(moduleId) {
    if (!moduleId) {
      setSubjects([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getSubjectByModule";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("role", role);
      fd.append("module", moduleId);

      const response = await api.post("subject/subjectCurl", fd);
      const data = Array.isArray(response.data.data) ? response.data.data : [];

      setSubjects(data);
      return data;
    } catch (error) {
      setSubjects([]);
    }
  }

  async function fetchChapters(subjectId) {
    if (!subjectId) {
      setChapters([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getChapterOnChange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("subjectId", subjectId);

      const chapterResponse = await api.post("onchange/onchangeCurl", fd);
      if (Array.isArray(chapterResponse.data.data)) {
        setChapters(chapterResponse.data.data);
      } else {
        setChapters([]);
      }
    } catch (error) {
      setChapters([]);
    }
  }

  async function fetchTopics(subjectId, chapterId) {
    if (!subjectId || !chapterId) {
      setTopics([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getTopicOnChange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("subjectId", subjectId);
      fd.append("chapterId", chapterId);

      const topicResponse = await api.post("onchange/onchangeCurl", fd);
      console.log("t", topicResponse)
      if (Array.isArray(topicResponse.data.data)) {
        setTopics(topicResponse.data.data);
      } else {
        setTopics([]);
      }
    } catch (error) {
      setTopics([]);
    }
  }

  async function fetchExamType() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getExamTypes");

      const response = await api.post("question/examType", fd);

      if (response.data?.status) {
        const options = response.data.examTypes.map((exam) => ({
          value: exam.id,
          label: exam.examType,
        }));

        setExamTypes(options);
      }
    } catch (error) {
      console.error("Error fetching exam types:", error);
    }
  }

  async function fetchLevel() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getLevelDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("level/levelCurl", fd);
      if (Array.isArray(response.data.getLevelDetails)) {
        setLevels(response.data.getLevelDetails);
      } else {
        setLevels([]);
      }
    } catch (error) {
      setLevels([]);
    }
  }

  async function fetchQuestionType() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getQuestionTypeDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("questionType/questionTypeCurl", fd);
      if (Array.isArray(response.data.getQuestionTypeDetails)) {
        setQuestionType(response.data.getQuestionTypeDetails);
      } else {
        setQuestionType([]);
      }
    } catch (error) {
      setQuestionType([]);
    }
  }

  const handleQuestionTypeChange = (e) => {
    const selectedType = e.target.value;
    setSelectedQuestionType(selectedType);

    const selectedQuestion = questionType.find(
      (type) => type.id === selectedType
    );
    if (selectedQuestion) {
      const numOfOptions = parseInt(selectedQuestion.options, 10);
      setOptions(Array(numOfOptions).fill(""));
    }
  };

  async function handleAddChapter() {
    if (!selectedSubject) {
      toast.error("Please select Subject first");
      return;
    }

    if (!newChapterName.trim()) {
      toast.error("Please enter chapter name");
      return;
    }

    setChapterLoading(true);

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("programType", "addChapter");
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("subject", selectedSubject);
      fd.append("chapter", newChapterName.trim());

      const res = await api.post("chapter/chapterCurl", fd);

      if (res.data?.status === true) {
        toast.success("Chapter added");

        await fetchChapters(selectedSubject);

        const added = res.data?.insertedId;
        if (added) setSelectedChapter(String(added));

        setShowAddChapter(false);
        setNewChapterName("");
      } else {
        toast.error(res.data?.data || "Failed to add chapter");
      }
    } catch {
      toast.error("Error adding chapter");
    } finally {
      setChapterLoading(false);
    }
  }
  async function handleAddTopic() {
    if (!selectedSubject || !selectedChapter) {
      toast.error("Select Subject and Chapter first");
      return;
    }

    if (!newTopicName.trim()) {
      toast.error("Please enter topic name");
      return;
    }

    setTopicLoading(true);

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("programType", "addTopic");
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("subject", selectedSubject);
      fd.append("chapter", selectedChapter);
      fd.append("topic", newTopicName.trim());

      const res = await api.post("topic/topicCurl", fd);

      if (res.data?.status === true) {
        toast.success("Topic added");

        await fetchTopics(selectedSubject, selectedChapter);

        const added = res.data?.insertedId;
        if (added) setSelectedTopic(String(added));

        setShowAddTopic(false);
        setNewTopicName("");
      } else {
        toast.error(res.data?.data || "Failed to add topic");
      }
    } catch {
      toast.error("Error adding topic");
    } finally {
      setTopicLoading(false);
    }
  }


  const stripHtmlTags = (html) => {
    let doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedModule) {
      toast.error("Please select Class.");
      return;
    }
    if (!selectedSubject) {
      toast.error("Please select Subject.");
      return;
    }
    if (!selectedChapter) {
      toast.error("Please select Chapter.");
      return;
    }
    if (!selectedTopic) {
      toast.error("Please select Topic.");
      return;
    }
    if (!selectedQuestionType) {
      toast.error("Please select Question Type.");
      return;
    }

    setSubmitting(true);

    const processedQuestion = await processContent(questionText);
    const processedExplanation = await processContent(explanation);
    const processedOptions = await Promise.all(
      optionValues.map(processContent)
    );

    const programType = ID ? "editQuestion" : "addQuestion";
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");

    const fd = new FormData();
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("programType", programType);
    fd.append("module", selectedModule);
    fd.append("course", selectedCourse);
    fd.append("subject", selectedSubject);
    fd.append("chapter", selectedChapter);
    fd.append("topic", selectedTopic);



    if (selectedLevel) {
      fd.append("level", selectedLevel);
    }

    fd.append("questionType", selectedQuestionType);
    if (selectedExamType.length > 0) {
      selectedExamType.forEach((exam) => {
        fd.append("examType[]", exam.value);
      });
    }

    tags.forEach((tag) => {
      fd.append("tags[]", tag);
    });


    fd.append("noOfOptions", noOfOptions);

    fd.append("question", processedQuestion);
    if (processedExplanation) {
      fd.append("explanation", processedExplanation);
    }
    fd.append("answer", answer);

    if (ID) fd.append("id", ID);

    processedOptions.forEach((option, index) => {
      fd.append(`option${index + 1}`, option);
    });

    fd.entries().forEach(([key, value]) => {
      console.log(key, value);
    });


    try {
      const response = await api.post("question/questionCurl", fd);
      console.log("Response:", response);

      if (response.data.status === true) {
        toast.success(
          id ? "Question updated successfully" : "Question added successfully"
        );

        if (ID) {
          navigate(-1);
        }

        // Reset form
        setSelectedModule("");
        setSelectedCourse("");
        setSelectedSubject("");
        setSelectedChapter("");
        setSelectedTopic("");
        setSelectedLevel("");
        setSelectedQuestionType("");
        setSelectedExamType("");
        setQuestionText("");
        setOptionValues(["", "", "", ""]);
        setExplanation("");
        setAnswer("");

        setTags([]);
        setTagInput("");


      } else {
        toast.error(response.data.data);
      }
    } catch (error) {
      toast.error("Error submitting question");
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
  if (ID && examTypes.length > 0) {
    fetchQuestionDetails();
  }
}, [examTypes]);

  const fetchQuestionDetails = async () => {
    if (!id) return;

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getDetailsForUpdate";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("id", id);

    try {
      const response = await api.post("question/questionCurl", fd);
      console.log("get details for update", response)

      if (response.data) {
        const questionDetails = Array.isArray(response.data)
          ? response.data[0]
          : response.data;

        const moduleId = questionDetails.moduleId;
        const subjectId = questionDetails.subjectId;
        const chapterId = questionDetails.chapterId;
        const topicId = questionDetails.topicId;

        setSelectedModule(moduleId);

        // load dependent data in order
        await fetchSubjects(moduleId);
        setSelectedSubject(subjectId);

        await fetchChapters(subjectId);
        setSelectedChapter(chapterId);

        await fetchTopics(subjectId, chapterId);
        setSelectedTopic(topicId);

        setSelectedLevel(questionDetails.levelId);
        setSelectedQuestionType(questionDetails.questionType);
      if (questionDetails.examType && examTypes.length > 0) {
  const ids = questionDetails.examType.split(",");

  const selected = examTypes.filter((exam) =>
    ids.includes(String(exam.value))
  );

  setSelectedExamType(selected);
}
        setQuestionText(questionDetails.question);
        setExplanation(questionDetails.explanation);
        setAnswer(questionDetails.optionId);


        let parsedOptions = [];
        if (questionDetails.options) {
          if (Array.isArray(questionDetails.options)) {
            parsedOptions = questionDetails.options;
          } else {
            try {
              parsedOptions = JSON.parse(questionDetails.options);
            } catch (error) {
              parsedOptions = questionDetails.options
                .split(",")
                .map((opt) => opt.trim());
            }
          }
        }

        if (parsedOptions.length > 0) {
          setOptionValues(parsedOptions);
        }
      }
    } catch (error) {
      toast.error("Error fetching question details");
      console.error(error);
    }
  };

  useEffect(() => {
    if (selectedQuestionType) {
      const selectedType = questionType.find(
        (type) => type.id === selectedQuestionType
      );
      if (selectedType) {
        const numOfOptions = parseInt(selectedType.options) || 0;
        setNoOfOptions(numOfOptions);

        setOptionValues((prevOptions) => {
          return prevOptions.length === 0 ||
            prevOptions.every((opt) => opt === "")
            ? Array(numOfOptions).fill("")
            : prevOptions;
        });
      }
    }
  }, [selectedQuestionType]);

  useEffect(() => {
    if (selectedModule) {
      fetchCourses(selectedModule);
    }
  }, [selectedModule]);

  useEffect(() => {
    if (!ID && !selectedSubject) {
      setSelectedChapter("");
      setSelectedTopic("");
    }

    if (selectedSubject) {
      fetchChapters(selectedSubject);
    }
  }, [selectedSubject, ID]);


  useEffect(() => {
    if (selectedSubject && selectedChapter) {
      fetchTopics(selectedSubject, selectedChapter);
    }
  }, [selectedSubject, selectedChapter]);

  useEffect(() => {
    fetchQuestionDetails();
  }, [id]);

  useEffect(() => {
    fetchModules();
    fetchExamType();
    fetchLevel();
    fetchQuestionType();
  }, []);

  const handleImageUpload = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const sanitizeHtml = (html) => {
    let safeHtml = html.replace(/\\/g, '___BACKSLASH___');
    let doc = new DOMParser().parseFromString(safeHtml, "text/html");

    const paragraphs = doc.body.querySelectorAll("p");
    paragraphs.forEach((p) => {
      if (p.parentElement === doc.body) {
        p.outerHTML = p.innerHTML;
      }
    });

    let output = doc.body.innerHTML;
    return output.replace(/___BACKSLASH___/g, '\\');
  };

  const convertImagesToBase64 = async (htmlContent) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");
    const images = doc.querySelectorAll("img");

    const imagePromises = Array.from(images).map(async (img) => {
      const imageUrl = img.getAttribute("src");

      if (imageUrl.startsWith("blob") || imageUrl.startsWith("file")) {
        try {
          const response = await fetch(imageUrl);
          const blob = await response.blob();
          const base64 = await handleImageUpload(blob);

          img.setAttribute("src", base64);
          img.setAttribute(
            "style",
            "max-width: 10px; height: 10px;object-fit: contain; display: block; margin: 10px 0;"
          );
        } catch (error) {
          console.error("Error converting image:", error);
        }
      }
    });

    await Promise.all(imagePromises);
    return doc.body.innerHTML;
  };

  const processContent = async (content) => {
    const base64Content = await convertImagesToBase64(content);
    const latexFormatted = convertToLatexInline(base64Content);
    return sanitizeHtml(latexFormatted);
  };

  const handleTextChange = async (htmlValue) => {
    const updatedContent = await processContent(htmlValue);
    setQuestionText(updatedContent);
  };

  const handleOptionChange = async (index, value) => {
    const updatedContent = await processContent(value);
    setOptionValues((prevOptions) => {
      const newOptions = [...prevOptions];
      newOptions[index] = updatedContent;
      return newOptions;
    });
  };

  const convertToLatexInline = (content) => {
    return content.replace(/\(({{[^()]+}}|frac{[^()]+})\)/g, (match, inner) => {
      return `\\(${inner}\\)`;
    });
  };

  const handleExplanationChange = async (e) => {
    const updatedContent = await processContent(
      e?.htmlValue || e?.target?.value || ""
    );
    setExplanation(updatedContent);
  };

  const renderLatexText = (text) => {
    if (!text) return null;

    let decodedText = he.decode(text);
    decodedText = decodedText.replace(/<br\s*\/?>/gi, "\n");

    const latexAndImageRegex =
      /\\\((.*?)\\\)|\\\[(.*?)\\\]|<img[^>]*\bsrc=(["'])(.*?)\3[^>]*>|\\begin{align}([\s\S]*?)\\end{align}/g;

    const parts = [];
    let lastIndex = 0;
    let match;
    let key = 0;

    while ((match = latexAndImageRegex.exec(decodedText)) !== null) {
      const [fullMatch, inlineLatex, blockLatex, , imageSrc, alignContent] = match;
      const matchIndex = match.index;

      if (matchIndex > lastIndex) {
        const plainText = decodedText.slice(lastIndex, matchIndex);
        plainText.split("\n").forEach((line, i, arr) => {
          if (line) parts.push(<span key={`html-${key++}`}>{line}</span>);
          if (i < arr.length - 1) parts.push(<br key={`br-${key++}`} />);
        });
      }

      if (imageSrc) {
        parts.push(
          <img
            key={`img-${key++}`}
            src={imageSrc}
            alt="Image"
            style={{
              maxWidth: `calc(16px * 18)`,
              display: "inline",
              verticalAlign: "middle",
              marginLeft: "4px",
              marginRight: "4px",
            }}
          />
        );
      } else if (alignContent) {
        parts.push(
          <BlockMath key={`align-${key++}`}>
            {`\\begin{align}${alignContent}\\end{align}`}
          </BlockMath>
        );
      } else if (inlineLatex || blockLatex) {
        parts.push(
          <InlineMath key={`inline-${key++}`}>
            {inlineLatex || blockLatex}
          </InlineMath>
        );
      }

      lastIndex = matchIndex + fullMatch.length;
    }

    if (lastIndex < decodedText.length) {
      const remaining = decodedText.slice(lastIndex);
      remaining.split("\n").forEach((line, i, arr) => {
        if (line) parts.push(<span className="normal-inline" key={`html-${key++}`}>{line}</span>);
        if (i < arr.length - 1) parts.push(<br key={`br-${key++}`} />);
      });
    }

    return <span style={{ whiteSpace: "normal", display: "inline" }}>{parts}</span>;
  };

  const renderPreview = () => {
    return (
      <div className="preview-container">
        <div className="preview-card">
          <div className="preview-header">
            <h4>📝 Question Preview</h4>
            <button className="close-preview" onClick={() => setShowPreview(false)}>
              <FiX size={20} />
            </button>
          </div>

          <div className="preview-content">
            <div className="question-preview">
              <h5>Question:</h5>
              <div className="question-text">
                {renderLatexText(questionText)}
              </div>
            </div>

            {optionValues.length > 0 && optionValues.some(opt => opt.trim() !== "") && (
              <div className="options-preview">
                <h5>Options:</h5>
                <div className="options-grid">
                  {optionValues.map((option, index) => (
                    option.trim() !== "" && (
                      <div key={index} className="option-preview">
                        <div className="option-letter">{index + 1}</div>
                        <div className="option-text">
                          {renderLatexText(option)}
                        </div>
                      </div>
                    )
                  ))}
                </div>
              </div>
            )}

            {answer && (
              <div className="answer-preview">
                <h5>Answer:</h5>
                <div className="answer-text">
                  {selectedQuestionType &&
                    questionType.find(type => type.id === selectedQuestionType)?.options === "0"
                    ? answer
                    : `Option ${answer}`
                  }
                </div>
              </div>
            )}

            {explanation && (
              <div className="explanation-preview">
                <h5>Explanation:</h5>
                <div className="explanation-text">
                  {renderLatexText(explanation)}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const resetForm = () => {
    setSelectedModule("");
    setSelectedCourse("");
    setSelectedSubject("");
    setSelectedChapter("");
    setSelectedTopic("");
    setSelectedLevel("");
    setSelectedQuestionType("");
    setSelectedExamType("");
    setQuestionText("");
    setOptionValues(["", "", "", ""]);
    setExplanation("");
    setAnswer("");
    toast.success("Form reset successfully!");
  };

  return (
    <div className="add-question-container">
      <ToastContainer />




      {/* Main Form */}
      <div className="add-question-main">
        <form onSubmit={handleSubmit} className="question-form">
          {/* Category Selection Card */}
          <div className="form-card">

            <div className="card-content">
              <div className="form-grid">
                {/* Class */}
                <div className="form-group">
                  <label className="form-label">
                    <FiBook /> Class <span className="required">*</span>
                  </label>
                  <select
                    className="form-select"
                    value={selectedModule}
                    onChange={(e) => {
                      const moduleId = e.target.value;
                      setSelectedModule(moduleId);
                      setSelectedSubject("");
                      setSelectedChapter("");
                      setSelectedTopic("");
                      setSubjects([]);
                      setChapters([]);
                      setTopics([]);
                      fetchCourses(moduleId);
                      fetchSubjects(moduleId);
                    }}
                  >
                    <option value="">Select a Class</option>
                    {modules.map((module) => (
                      <option key={module.id} value={module.id}>
                        {module.moduleName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Subject */}
                <div className="form-group">
                  <label className="form-label">
                    <FiFileText /> Subject <span className="required">*</span>
                  </label>
                  <select
                    className="form-select"
                    value={selectedSubject}
                    onChange={(e) => {
                      const subjectId = e.target.value;
                      setSelectedSubject(subjectId);
                    }}
                  >
                    <option value="">Select a Subject</option>
                    {subjects.map((subject) => (
                      <option key={subject.id} value={subject.id}>
                        {subject.subjectName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Chapter */}
                <div className="form-group">
                  <label className="form-label">
                    <FiList /> Chapter <span className="required">*</span>
                  </label>
                  <select
                    className="form-select"
                    value={selectedChapter}
                    onChange={(e) => {
                      if (e.target.value === "__add__") {
                        setShowAddChapter(true);
                        return;
                      }
                      const chapterId = e.target.value;
                      setSelectedChapter(chapterId);
                      fetchTopics(selectedSubject, chapterId);
                    }}
                  >
                    <option value="">Select a Chapter</option>

                    {/* ✅ Show only after Subject selected */}
                    {selectedSubject && (
                      <option value="__add__">➕ Add Chapter</option>
                    )}

                    {chapters.map((chapter) => (
                      <option key={chapter.id} value={chapter.id}>
                        {chapter.chapterName}
                      </option>
                    ))}
                  </select>

                </div>

                {/* Topic */}
                <div className="form-group">
                  <label className="form-label">
                    <FiList /> Topic <span className="required">*</span>
                  </label>
                  <select
                    className="form-select"
                    value={selectedTopic}
                    onChange={(e) => {
                      if (e.target.value === "__add__") {
                        setShowAddTopic(true);
                        return;
                      }
                      setSelectedTopic(e.target.value);
                    }}
                  >
                    <option value="">Select a Topic</option>

                    {/* ✅ Show only after Chapter selected */}
                    {selectedChapter && (
                      <option value="__add__">➕ Add Topic</option>
                    )}

                    {topics.map((topic) => (
                      <option key={topic.id} value={topic.id}>
                        {topic.topicName}
                      </option>
                    ))}
                  </select>

                </div>

                {/* Level */}
                <div className="form-group">
                  <label className="form-label">
                    <FiAward /> Level
                  </label>
                  <select
                    className="form-select"
                    value={selectedLevel}
                    onChange={(e) => setSelectedLevel(e.target.value)}
                  >
                    <option value="">Select a Level</option>
                    {levels.map((level) => (
                      <option key={level.id} value={level.id}>
                        {level.levelName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Question Type */}
                <div className="form-group">
                  <label className="form-label">
                    <FiType /> Question Type <span className="required">*</span>
                  </label>
                  <select
                    className="form-select"
                    value={selectedQuestionType}
                    onChange={handleQuestionTypeChange}
                  >
                    <option value="">Select Question Type</option>
                    {questionType.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.questionType} ({type.options} options)
                      </option>
                    ))}
                  </select>
                </div>

                {/* Exam Type */}
                <div className="form-group">
                  <label className="form-label">
                    <FiHelpCircle /> Exam Type
                  </label>
                  <Select
                    options={examTypes}
                    isMulti
                    value={selectedExamType}
                    onChange={(selected) => setSelectedExamType(selected)}
                    placeholder="Select Exam Types"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </div>

                {/* Tags */}
                <div className="form-group">
                  <label className="form-label">
                    <FiList /> Tags
                  </label>

                  <input
                    type="text"
                    className="form-input"
                    placeholder="Type tag and press Enter"
                    value={tagInput}
                    onChange={(e) => setTagInput(e.target.value)}
                    onKeyDown={handleTagKeyDown}
                  />

                  {/* Tag list */}
                  <div className="tag-container">
                    {tags.map((tag, index) => (
                      <span key={index} className="tag-item">
                        {tag}
                        <button
                          type="button"
                          className="tag-remove"
                          onClick={() => removeTag(index)}
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Question Content Card */}
          <div className="form-card">
            <div className="card-header">
              <h3><FiEdit /> Question Content</h3>
              <p className="card-subtitle">Enter the question text, options, and answer</p>
            </div>

            <div className="card-content">
              {/* Question Text */}
              <div className="form-group full-width">
                <label className="form-label">
                  Question Text <span className="required">*</span>
                </label>
                <div className="editor-container">
                  <Editor
                    value={questionText}
                    onTextChange={(e) => handleTextChange(e.htmlValue)}
                    style={{ height: '150px' }}
                    placeholder="Enter the question here..."
                  />
                </div>
              </div>

              {/* Options Section */}
              {selectedQuestionType && optionValues.length > 0 && (
                <div className="options-section">
                  <h4>Options</h4>
                  <div className="options-grid">
                    {optionValues.map((_, index) => (
                      <div key={index} className="option-editor">
                        <label className="option-label">
                          Option {index + 1} <span className="required">*</span>
                        </label>
                        <Editor
                          value={optionValues[index]}
                          onTextChange={(e) => handleOptionChange(index, e.htmlValue)}
                          style={{ height: '100px' }}
                          placeholder={`Enter option ${index + 1}...`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Answer Selection */}
              {selectedQuestionType && (
                <div className="answer-section">
                  <h4>Correct Answer</h4>
                  {selectedQuestionType &&
                    Number(
                      questionType.find(
                        (type) => type.id === selectedQuestionType
                      )?.options
                    ) === 0 ? (
                    <div className="text-answer">
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Enter your answer"
                        value={answer}
                        onChange={(e) => setAnswer(e.target.value)}
                        required
                      />
                    </div>
                  ) : (
                    <div className="multiple-choice-answer">
                      <div className="answer-options">
                        {optionValues.map((_, index) => (
                          <label key={index} className="answer-option">
                            <input
                              type="radio"
                              name="answer"
                              value={index + 1}
                              checked={answer === `${index + 1}`}
                              onChange={() => setAnswer(`${index + 1}`)}
                              className="answer-radio"
                            />
                            <span className="answer-label">Option {index + 1}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Explanation */}
              <div className="form-group full-width">
                <label className="form-label">Explanation</label>
                <div className="editor-container">
                  <Editor
                    value={explanation}
                    onTextChange={handleExplanationChange}
                    style={{ height: '150px' }}
                    placeholder="Enter explanation (optional)..."
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Form Actions */}
          <div className="form-actions">
            <button
              type="button"
              className="btn btn-danger"
              onClick={resetForm}
              disabled={submitting}
            >
              <FiXCircle /> Reset
            </button>

            <button
              type="button"
              className="btn preview"
              onClick={() => setShowPreview(true)}
              disabled={submitting}
            >
              <FiEye /> Preview
            </button>

            <button
              type="submit"
              className="btn primary"
              disabled={submitting}
            >
              {submitting ? (
                <>
                  <div className="spinner"></div>
                  {ID ? "Updating..." : "Submitting..."}
                </>
              ) : (
                <>
                  <FiSave /> {ID ? "Update Question" : "Submit Question"}
                </>
              )}
            </button>
          </div>
        </form>
      </div>

      {/* Preview Modal */}
      {showPreview && renderPreview()}

      <style>
        {`
          .add-question-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
            padding: 1.5rem;
          }

        
/* ===== ADD CHAPTER / TOPIC MODAL ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* 🔥 THIS IS THE KEY */
}

.modal-card {
  background: #ffffff;
  padding: 24px;
  border-radius: 12px;
  width: 420px;
  max-width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-card h3 {
  margin-bottom: 16px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.tag-item {
  background: #e0f2fe;
  color: #0369a1;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.tag-remove {
  border: none;
  background: transparent;
  margin-left: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #0369a1;
}

       
          /* Header */
          .add-question-header {
            background: white;
            border-radius: 1rem;
            padding: 1.5rem;
            margin-bottom: 1.5rem;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            border: 1px solid #e2e8f0;
          }

          .header-content h1 {
            font-size: 1.75rem;
            font-weight: 700;
            color: #1f2937;
            margin: 0 0 0.5rem;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .header-content p {
            font-size: 0.875rem;
            color: #6b7280;
            margin: 0 0 1rem;
          }

          /* Breadcrumb */
          .breadcrumb {
            padding-top: 1rem;
            border-top: 1px solid #f3f4f6;
          }

          .breadcrumb-list {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .breadcrumb-list li {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .breadcrumb-item {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            color: #6b7280;
            text-decoration: none;
            font-size: 0.875rem;
            transition: color 0.2s;
          }

          .breadcrumb-item:hover {
            color: #3b82f6;
          }

          .breadcrumb-item.active {
            color: #1f2937;
            font-weight: 500;
          }

          .breadcrumb-separator {
            color: #9ca3af;
            width: 16px;
            height: 16px;
          }

          /* Main Form */
          .add-question-main {
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
          }

          /* Form Cards */
          .form-card {
            background: white;
            border-radius: 1rem;
            border: 1px solid #e2e8f0;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            overflow: hidden;
          }

          .card-header {
            padding: 1.25rem 1.5rem;
            border-bottom: 1px solid #f3f4f6;
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          }

          .card-header h3 {
            font-size: 1.125rem;
            font-weight: 600;
            color: #1f2937;
            margin: 0 0 0.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .card-subtitle {
            font-size: 0.875rem;
            color: #6b7280;
            margin: 0;
          }

          .card-content {
            padding: 1.5rem;
          }

          /* Form Grid */
          .form-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 1.5rem;
          }

          .form-group {
          }

          .form-group.full-width {
            grid-column: 1 / -1;
          }

          .form-label {
            display: block;
            font-size: 0.875rem;
            font-weight: 600;
            color: #374151;
            margin-bottom: 0.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .required {
            color: #ef4444;
            font-weight: 600;
          }

          /* Form Controls */
          .form-select, .form-input {
            width: 100%;
            padding: 0.625rem 0.875rem;
            border: 1px solid #e5e7eb;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            color: #374151;
            background: white;
            transition: all 0.2s;
          }

          .form-select:focus, .form-input:focus {
            outline: none;
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          }

          /* Editor */
          .editor-container {
            border: 1px solid #e5e7eb;
            border-radius: 0.5rem;
            overflow: hidden;
          }

          .editor-container .p-editor-container {
            border: none !important;
          }

          .editor-container .p-editor-toolbar {
            background: #f9fafb;
            border-bottom: 1px solid #e5e7eb;
            border-radius: 0.5rem 0.5rem 0 0;
          }

          .editor-container .p-editor-content {
            border: none !important;
          }

          /* Options Section */
          .options-section {
            margin-top: 2rem;
            padding-top: 1.5rem;
            border-top: 1px solid #f3f4f6;
          }

          .options-section h4 {
            font-size: 1rem;
            font-weight: 600;
            color: #374151;
            margin: 0 0 1rem;
          }

          .options-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 1.5rem;
          }

          .option-editor {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
          }

          .option-label {
            font-size: 0.875rem;
            font-weight: 600;
            color: #374151;
          }

          /* Answer Section */
          .answer-section {
            margin-top: 2rem;
            padding-top: 1.5rem;
            border-top: 1px solid #f3f4f6;
          }

          .answer-section h4 {
            font-size: 1rem;
            font-weight: 600;
            color: #374151;
            margin: 0 0 1rem;
          }

          .text-answer .form-input {
            max-width: 400px;
          }

          .multiple-choice-answer .answer-options {
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
          }

          .answer-option {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.75rem 1rem;
            background: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: 0.5rem;
            cursor: pointer;
            transition: all 0.2s;
          }

          .answer-option:hover {
            background: #f3f4f6;
          }

          .answer-radio {
            width: 1.25rem;
            height: 1.25rem;
            cursor: pointer;
          }

          .answer-label {
            font-size: 0.875rem;
            font-weight: 500;
            color: #374151;
          }

          /* Form Actions */
          .form-actions {
            display: flex;
            justify-content: flex-end;
            gap: 1rem;
            padding: 1.5rem;
            background: white;
            border-radius: 1rem;
            border: 1px solid #e2e8f0;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          }

          .btn {
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.75rem 1.5rem;
            border: none;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
          }

          .btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          .btn.primary {
            background: #3b82f6;
            color: white;
          }

          .btn.primary:hover:not(:disabled) {
            background: #2563eb;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
          }

          .btn.secondary {
            background: #f3f4f6;
            color: #374151;
            border: 1px solid #e5e7eb;
          }

          .btn.secondary:hover:not(:disabled) {
            background: #e5e7eb;
          }

          .btn.preview {
            background: #8b5cf6;
            color: white;
          }

          .btn.preview:hover:not(:disabled) {
            background: #7c3aed;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(139, 92, 246, 0.2);
          }

          .spinner {
            width: 16px;
            height: 16px;
            border: 2px solid rgba(255, 255, 255, 0.3);
            border-radius: 50%;
            border-top-color: white;
            animation: spin 1s linear infinite;
            margin-right: 0.5rem;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }

          /* Preview Modal */
          .preview-container {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
            backdrop-filter: blur(3px);
            padding: 1rem;
          }

          .preview-card {
            background: white;
            border-radius: 1rem;
            width: 100%;
            max-width: 800px;
            max-height: 80vh;
            overflow: hidden;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
          }

          .preview-header {
            padding: 1.5rem;
            border-bottom: 1px solid #f3f4f6;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .preview-header h4 {
            font-size: 1.25rem;
            font-weight: 600;
            color: #1f2937;
            margin: 0;
          }

          .close-preview {
            background: none;
            border: none;
            color: #9ca3af;
            cursor: pointer;
            padding: 0.5rem;
            border-radius: 0.5rem;
            transition: all 0.2s;
          }

          .close-preview:hover {
            background: #f3f4f6;
            color: #374151;
          }

          .preview-content {
            padding: 1.5rem;
            overflow-y: auto;
            max-height: calc(80vh - 80px);
          }

          .question-preview, .options-preview, .answer-preview, .explanation-preview {
            margin-bottom: 1.5rem;
          }

          .question-preview h5, .options-preview h5, .answer-preview h5, .explanation-preview h5 {
            font-size: 1rem;
            font-weight: 600;
            color: #374151;
            margin: 0 0 0.75rem;
          }

          .question-text, .explanation-text {
            font-size: 0.9375rem;
            line-height: 1.6;
            color: #4b5563;
            padding: 1rem;
            background: #f9fafb;
            border-radius: 0.5rem;
            border: 1px solid #f3f4f6;
          }

          .options-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 0.75rem;
          }

          .option-preview {
            display: flex;
            gap: 0.75rem;
            padding: 0.875rem;
            background: #f9fafb;
            border-radius: 0.5rem;
            border: 1px solid #f3f4f6;
          }

          .option-letter {
            width: 1.5rem;
            height: 1.5rem;
            background: #e5e7eb;
            color: #374151;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            font-size: 0.75rem;
            flex-shrink: 0;
          }

          .option-text {
            font-size: 0.875rem;
            line-height: 1.5;
            color: #1f2937;
            flex: 1;
          }

          .answer-text {
            font-size: 0.9375rem;
            font-weight: 600;
            color: #065f46;
            padding: 0.75rem 1rem;
            background: #d1fae5;
            border-radius: 0.5rem;
            display: inline-block;
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .add-question-container {
              padding: 1rem;
            }

            .form-grid {
              grid-template-columns: 1fr;
            }

            .options-grid {
              grid-template-columns: 1fr;
            }

            .form-actions {
              flex-direction: column;
            }

            .btn {
              width: 100%;
              justify-content: center;
            }
          }

          @media (max-width: 480px) {
            .add-question-header {
              padding: 1rem;
            }

            .header-content h1 {
              font-size: 1.5rem;
            }

            .card-content {
              padding: 1rem;
            }

            .preview-card {
              margin: 1rem;
            }
          }
        `}
      </style>

      {showAddChapter && (
        <div className="modal-overlay">
          <div className="modal-card">
            <h3>➕ Add Chapter</h3>

            <input
              className="form-control"
              value={newChapterName}
              onChange={(e) => setNewChapterName(e.target.value)}
              placeholder="Enter chapter name"
            />

            <div className="modal-actions">
              <button className="btn btn-danger" onClick={() => setShowAddChapter(false)}>
                Cancel
              </button>
              <button className="btn primary" onClick={handleAddChapter} disabled={chapterLoading}>
                {chapterLoading ? "Adding..." : "Add Chapter"}
              </button>
            </div>
          </div>
        </div>
      )}


      {showAddTopic && (
        <div className="modal-overlay">
          <div className="modal-card">
            <h3>➕ Add Topic</h3>

            <input
              className="form-control"
              value={newTopicName}
              onChange={(e) => setNewTopicName(e.target.value)}
              placeholder="Enter topic name"
            />

            <div className="modal-actions">
              <button className="btn btn-danger" onClick={() => setShowAddTopic(false)}>
                Cancel
              </button>
              <button className="btn primary" onClick={handleAddTopic} disabled={topicLoading}>
                {topicLoading ? "Adding..." : "Add Topic"}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default AddQuestion;